const middleware = {};
middleware['aff-everflow'] = require('../middleware/aff-everflow.js');
middleware['aff-everflow'] = middleware['aff-everflow'].default || middleware['aff-everflow'];
middleware['app-detection'] = require('../middleware/app-detection.js');
middleware['app-detection'] = middleware['app-detection'].default || middleware['app-detection'];
middleware['experiment-tagging'] = require('../middleware/experiment-tagging.js');
middleware['experiment-tagging'] = middleware['experiment-tagging'].default || middleware['experiment-tagging'];
middleware['members-auth'] = require('../middleware/members-auth.js');
middleware['members-auth'] = middleware['members-auth'].default || middleware['members-auth'];
export default middleware;